import api from './api'

export type DashboardFiltro = {
  dataInicio?: string
  dataFim?: string
  categoria?: string
  servicos?: number[]
  cidades?: string[]
  captacoes?: string[]
}

export type FiltrosDisponiveis = {
  dataMinima: string | null
  dataMaxima: string | null
  categorias: string[]
  captacoes: string[]
  servicos: { id: number; nome: string; categoria: string }[]
  cidades: { cidade: string; qtdPacientes: number }[]
}

export type VisaoGeral = {
  dataInicio: string
  dataFim: string
  granularidade: 'DIA' | 'MES'
  kpis: {
    totalOrcado: number
    totalVendido: number
    totalDesconto: number
    totalCancelado: number
    ticketMedioVendas: number
    qtdOrcamentos: number
    qtdVendas: number
    qtdCanceladas: number
  }
  servicosPorTipo: { servicoId: number; nome: string; categoria: string; quantidade: number; totalVendido: number }[]
  porCategoria: { categoria: string; totalOrcado: number; totalVendido: number; totalDesconto: number; qtdServicos: number }[]
  porCidade: { cidade: string; totalOrcado: number; totalVendido: number; qtdOrcamentos: number; qtdVendas: number }[]
  porPeriodo: { periodo: string; totalOrcado: number; totalVendido: number; qtdOrcamentos: number; qtdVendas: number }[]
  porStatus: { status: string; totalOrcado: number; totalVendido: number }[]
  vendidoPorCaptacao: { captacao: string; totalVendido: number; qtdVendas: number; qtdClientes: number }[]
}

export type Pacientes = {
  dataInicio: string
  dataFim: string
  kpis: {
    totalOrcado: number
    totalVendido: number
    coberturaClientes: number
    ticketMedioClientes: number
    qtdVendas: number
  }
  porCliente: {
    pacienteId: number
    nome: string
    totalOrcado: number
    totalVendido: number
    qtdOrcamentos: number
    qtdVendas: number
  }[]
  porIdade: { idade: number; totalOrcado: number; totalVendido: number }[]
  porCidade: VisaoGeral['porCidade']
  porGenero: { genero: string; totalVendido: number; qtdClientes: number }[]
  porCategoria: VisaoGeral['porCategoria']
  clientesPorCaptacao: { captacao: string; totalVendido: number; qtdVendas: number; qtdClientes: number }[]
}

function toQuery(filtro: DashboardFiltro) {
  const params = new URLSearchParams()
  if (filtro.dataInicio) params.append('dataInicio', filtro.dataInicio)
  if (filtro.dataFim) params.append('dataFim', filtro.dataFim)
  if (filtro.categoria) params.append('categoria', filtro.categoria)
  filtro.servicos?.forEach(s => params.append('servicos', String(s)))
  filtro.cidades?.forEach(c => params.append('cidades', c))
  filtro.captacoes?.forEach(c => params.append('captacoes', c))
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}

export async function fetchDashboardFiltros(): Promise<FiltrosDisponiveis> {
  const response = await api.get('/dashboard/filtros')
  return response?.data
}

export async function fetchVisaoGeral(filtro: DashboardFiltro): Promise<VisaoGeral> {
  const response = await api.get(`/dashboard/visao-geral${toQuery(filtro)}`)
  return response?.data
}

export async function fetchPacientes(filtro: DashboardFiltro): Promise<Pacientes> {
  const response = await api.get(`/dashboard/pacientes${toQuery(filtro)}`)
  return response?.data
}
